// 側欄底部（手機在篩選面板底部）的「Google 行事曆」入口（GDO-24）。
// 有遊戲的發售日變動時，右邊多一個「更新」按鈕，一次更新所有日期變動的遊戲（GDO-32）。
import type { IndexRow } from '@dayone/core/snapshot';
import { useCalendar, useDrifts } from '../../calendar/useCalendar.ts';
import { t } from '../../i18n/zh-TW.ts';
import { Hint } from '../../ui/Hint.tsx';
import { CalendarDays, ICON, RefreshCw } from '../../ui/icons/index.ts';

export function CalendarEntry({ rows }: { rows: readonly IndexRow[] }) {
  const cal = useCalendar();
  const drifts = useDrifts(cal, rows);
  if (!cal) return null;
  const sub =
    cal.auth === 'signed_in'
      ? (cal.calendars?.find((c) => c.id === cal.calendarId)?.name ?? t.gcal.chooseCalendar)
      : cal.auth === 'reauth'
        ? t.gcal.entryReauth
        : null;
  const updating = cal.progress !== null;
  return (
    <div className="gcal-entry-row">
      <button
        type="button"
        className={cal.auth === 'reauth' ? 'link-button gcal-entry gcal-entry-warn' : 'link-button gcal-entry'}
        onClick={cal.openPanel}
      >
        <CalendarDays {...ICON} />
        <span>
          {cal.auth === 'signed_in' || cal.auth === 'reauth' ? t.gcal.entry : t.gcal.entrySignedOut}
          {sub && <small>{sub}</small>}
        </span>
      </button>
      {(drifts.length > 0 || updating) && (
        <Hint content={t.gcal.entryUpdateHint(cal.progress?.total ?? drifts.length)}>
          <button
            type="button"
            className="gcal-entry-update"
            aria-disabled={updating || undefined}
            onClick={() => {
              if (!updating) void cal.updateAll(drifts);
            }}
          >
            <RefreshCw {...ICON} className={updating ? 'spin' : undefined} />
            <span className="gcal-entry-update-label">{t.gcal.entryUpdate}</span>
            <span className="gcal-entry-update-count num">
              {cal.progress ? t.gcal.entryUpdating(cal.progress.done, cal.progress.total) : drifts.length}
            </span>
          </button>
        </Hint>
      )}
    </div>
  );
}
